export const useListProps = (id: string | undefined) => {
  return {
    path: `/shipment-service/custom-data`,
    selectRowsEnabled: { enabled: false },
    actionBar: { enabled: false },
    pagination: { enabled: false },

    filters: {
      name: "customData",
      preserve: false,

      list: [
        {
          fieldName: "shipmentId",
          hidden: true,
          value: id,
        },
      ],
    },
  };
};
